import { useQuery } from "@tanstack/vue-query";
import CompanyAPI from "src/api/Company";

export function useCheckoutCustomizations() {
  return useQuery({
    queryKey: ["checkoutCustomizations"],
    queryFn: async () => {
      const response = await CompanyAPI.getCheckoutCustomizations();
      return response;
    },
  });
}
